import request from "@/utils/request";

// 获取
export function getForm(params) {
  return request({
    url: "/api/banner/get",
    method: "get",
    params,
  });
}